import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    url: String
  }
  
  connect() {
    this.timeout = null
    this.element.addEventListener("input", this.handleInput.bind(this))
  }

  disconnect() {
    clearTimeout(this.timeout)
    this.element.removeEventListener("input", this.handleInput.bind(this))
  }

  handleInput(event) {
    clearTimeout(this.timeout)
    
    const score = event.target.value
    
    this.timeout = setTimeout(() => {
      this.updatePreview(score)
    }, 300)
  }

  async updatePreview(score) {
    const url = `${this.urlValue}?score=${encodeURIComponent(score)}`
    
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest",
          "Turbo-Frame": "star_preview"
        }
      })
      
      if (response.ok) {
        const text = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(text, "text/html")
        const newFrame = doc.querySelector("turbo-frame#star_preview")
        
        if (newFrame) {
          const currentFrame = document.querySelector("turbo-frame#star_preview")
          if (currentFrame) {
            currentFrame.innerHTML = newFrame.innerHTML
          }
        }
      }
    } catch (error) {
      console.error("Error updating star preview:", error)
    }
  }
}